import './GenderRequired.sass';

import { FC, useCallback, useState } from 'react';
import { useDispatch } from 'react-redux';

import { Api } from '$api';
import { useCurrentUserInfo, useTranslator } from '$hooks';
import { mainActions } from '$store/main';
import { Sex, UserModel } from '$store/models';
import { toastActions } from '$store/toast';
import { Button, SegmentedControl } from '$uikit';

export const GenderRequired: FC = () => {
  const t = useTranslator();
  const dispatch = useDispatch();
  const user = useCurrentUserInfo();
  const [sex, setSex] = useState<Sex>(Sex.UNKNOWN);

  const handleSave = useCallback(() => {
    if (sex !== Sex.FEMALE && sex !== Sex.MALE) {
      dispatch(toastActions.setToastFail(t('reg_select_gender')));
      return;
    }

    dispatch(toastActions.setToastLoading());
    Api.post<any, { user?: UserModel }>('/profile/sex', { sex })
      .then((data) => {
        dispatch(mainActions.setUser(data?.user ?? { ...user, sex }));
        dispatch(toastActions.hideToast());
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
      });
  }, [dispatch, sex, t, user]);

  return (
    <div className="GenderRequired">
      <div className="GenderRequired__content">
        <div className="GenderRequired__title">{t('gender_required_title')}</div>
        <div className="GenderRequired__caption">{t('gender_required_caption')}</div>
        <SegmentedControl
          options={[
            { label: t('reg_gender_female'), value: Sex.FEMALE },
            { label: t('reg_gender_male'), value: Sex.MALE },
          ]}
          defaultValue={sex}
          onChange={setSex}
        />
        <Button stretched onClick={handleSave}>
          {t('continue')}
        </Button>
      </div>
    </div>
  );
};
